import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateDietTypeDto {
  @Expose()
  name: string;

  @Expose()
  default?: boolean;

  @Expose()
  color?: string;

  @Expose()
  includesAccommodationExpenses?: boolean;

  @Expose()
  @Transform(({ value }) => toCents(value))
  accommodationExpenses?: number;

  @Expose()
  payrollEquivalentDietTypeId?: string | null;
}
